import React from 'react';
import './PartnerAccessBanner.css';

function daysRemaining(endDate) {
  const diff = endDate.getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

/**
 * Banner shown when bootcamp partner access is nearing expiry.
 */
const PartnerAccessBanner = ({ partnerProUntil, onUpgrade, onDismiss }) => {
  if (!partnerProUntil) return null;

  const days = daysRemaining(partnerProUntil);
  const dayLabel = days === 1 ? 'day' : 'days';

  return (
    <div className="partner-access-banner" role="region" aria-label="Partner access ending soon">
      <div className="partner-access-banner__copy">
        <strong className="partner-access-banner__headline">
          Your free bootcamp access ends in {days} {dayLabel}
        </strong>
        <span className="partner-access-banner__subtext">
          Keep going for $7.99/mo
        </span>
      </div>
      <div className="partner-access-banner__actions">
        <button
          type="button"
          className="partner-access-banner__btn partner-access-banner__btn--primary"
          onClick={onUpgrade}
        >
          Upgrade now
        </button>
        <button
          type="button"
          className="partner-access-banner__btn partner-access-banner__btn--ghost"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default PartnerAccessBanner;
